// AUTO-GENERATED by generate-zod-schemas.ts — DO NOT EDIT
// Copyright 2026 Epic Digital Interactive Media LLC
// SPDX-License-Identifier: Apache-2.0

import { z } from 'zod'

export const relationSchema = z.object({
  id: z.string().max(100),
  orgId: z.string().max(100),
  workspaceId: z.string().max(100).optional(),
  userId: z.string().max(100).optional(),
  createdAt: z.string().max(200).datetime(),
  updatedAt: z.string().max(200).datetime(),
  metadata: z.record(z.string(), z.unknown()).optional(),
  extended: z.record(z.string(), z.unknown()).optional(),
  sourceId: z.string().max(100),
  sourceCollection: z.string().max(200),
  sourceSchemaId: z.string().max(100).optional(),
  targetId: z.string().max(100),
  targetCollection: z.string().max(200),
  targetSchemaId: z.string().max(100).optional(),
  relationType: z.string().max(200),
  data: z.record(z.string(), z.unknown()).optional(),
  sortOrder: z.number().int().min(0).max(999999).optional(),
  label: z.string().max(255).optional(),
  tenantId: z.string().max(100).optional(),
})

export type RelationInput = z.infer<typeof relationSchema>
